import { ChartProps } from 'react-chartjs-2';
import {
  red,
  blue,
  yellow,
  lime,
  purple,
  orange,
  pink,
  brown,
  lightBlue,
  teal,
} from '@mui/material/colors';

import { AdminReportRouteSummaryEvidenceItem } from '~services/admin/report/types';
import { formatPercentage } from '~utils/formatter';

type ReasonsForIncompleteVisitsChartProps = ChartProps<
  'doughnut',
  number[],
  string
>;

export const getReasonsForIncompleteVisitsChartProps = (
  rejectedReasons: AdminReportRouteSummaryEvidenceItem[],
): ReasonsForIncompleteVisitsChartProps => {
  const labels: string[] = [];
  const dataSet: number[] = [];

  rejectedReasons
    .filter((reason) => reason.quantity > 0)
    .sort((a, b) => b.quantity - a.quantity)
    .forEach((rejectedReason) => {
      labels.push(rejectedReason.evidence);
      dataSet.push(rejectedReason.avgEvidence);
    });

  const data: ReasonsForIncompleteVisitsChartProps['data'] = {
    labels,
    datasets: [
      {
        label: 'Motivo de visitias fallidas',
        data: dataSet,
        backgroundColor: [
          red[300],
          blue[300],
          yellow[300],
          lime[300],
          purple[300],
          orange[300],
          pink[300],
          brown[300],
          lightBlue[300],
          teal[300],
        ],
        borderColor: [
          red[500],
          blue[500],
          yellow[500],
          lime[500],
          purple[500],
          orange[500],
          pink[500],
          brown[500],
          lightBlue[500],
          teal[500],
        ],
      },
    ],
  };

  const options: ReasonsForIncompleteVisitsChartProps['options'] = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 10,
          },
          boxWidth: 15,
          boxHeight: 15,
          usePointStyle: true,
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) =>
            `${tooltipItem.label}: ${formatPercentage(tooltipItem.parsed, 2)}`,
        },
      },
    },
    maintainAspectRatio: false,
  };

  return { data, options, type: 'doughnut' };
};
